import { gql } from '@apollo/client';

export const CREATE_TABLE = gql`
  mutation CreateTable($params: CreateTableInput) {
    createTable(params: $params) {
      success
      message
      errors
      data {
        id
        schemaId
        schemaName
        tableName
        description
        purpose
        primaryKeyColumns
        keywords
        businessContext
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const UPDATE_TABLE = gql`
  mutation UpdateTable($params: UpdateTableInput) {
    updateTable(params: $params) {
      success
      message
      errors
      data {
        id
        schemaId
        schemaName
        tableName
        description
        purpose
        primaryKeyColumns
        keywords
        businessContext
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;

export const DELETE_TABLE = gql`
  mutation DeleteTable($params: DeleteTableInput) {
    deleteTable(params: $params) {
      success
      message
      errors
    }
  }
`;

export const CREATE_TABLE_EMBEDDING = gql`
  mutation CreateTableEmbedding($params: CreateTableEmbeddingInput!) {
    createTableEmbedding(params: $params) {
      success
      message
      errors
    }
  }
`;
